import Route from '@ember/routing/route';

export default class DashboardUrlKeywordsAddManualRoute extends Route {
  setupController(controller, model) {
    super.setupController(controller, model);
    controller.set('url', this.modelFor('dashboard.url'));
  }
}
